export default "__VITE_ASSET__DyNQUWcN__"